import type { RouteRecordRaw } from 'vue-router'

import { organizationDetailLayoutMeta } from './shared'

const routeCustomerDetail: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/relations/OrganizationDetailView.vue')
  },
  name: 'customer-detail',
  path: '',
}

const routeCustomerFileOverview: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/file/SubmenuFiles.vue')
  },
  name: 'customer-file-overview',
  path: 'file-overview',
}

const routeCustomerAccounting: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/customer/SubmenuAccounting.vue')
  },
  name: 'customer-accounting',
  path: 'customer-accounting',
}

/*const routeCustomerDelivery: RouteRecordRaw = { // TODO: not used?
  component: async () => {
    return await import('@/components/viewsExternal/submenus/customer/SubmenuDelivery.vue')
  },
  name: 'customer-delivery-note',
  path: 'customer-delivery-note',
}*/

const routeCustomerProjects: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/customer/SubmenuProjects.vue')
  },
  name: 'customer-projects',
  path: 'customer-projects',
}
const routeCustomerSales: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/customer/SubmenuSales.vue')
  },
  name: 'customer-sales',
  path: 'customer-sales',
}

const routeCustomerRoot: RouteRecordRaw = {
  children: [
    routeCustomerDetail,
    routeCustomerFileOverview,
    routeCustomerAccounting,
    //routeCustomerDelivery, // TODO: not used?
    routeCustomerProjects,
    routeCustomerSales,
  ],
  component: async () => {
    return await import('@/components/relationships/organizations/OrganizationDetailBase.vue')
  },
  meta: organizationDetailLayoutMeta,
  path: 'customers/:id',
}

export {
  routeCustomerAccounting,
  //routeCustomerDelivery, // TODO: not used?
  routeCustomerDetail,
  routeCustomerFileOverview,
  routeCustomerProjects,
  routeCustomerRoot,
  routeCustomerSales,
}
